import { render, staticRenderFns } from "./HealthCheck45PsaThyroidLiverNR.vue?vue&type=template&id=4b0f9049&scoped=true&"
import script from "./HealthCheck45PsaThyroidLiverNR.vue?vue&type=script&lang=js&"
export * from "./HealthCheck45PsaThyroidLiverNR.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck45PsaThyroidLiverNR.vue?vue&type=style&index=0&id=4b0f9049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f9049",
  null
  
)

export default component.exports